// extracted by mini-css-extract-plugin
module.exports = {"loading":"search_pagination_loader-module__loading--1eIHd"};